export const visualizeBFS = async (
  graph,
  setTraversedNode,
  setVisitedNodes,
  setQueueNodes,
  controller
) => {
  return new Promise((resolve) => {
    const bfsOrder = [];
    const visited = new Set();
    const queue = [];

    if (Object.keys(graph).length === 0) {
      resolve(bfsOrder);
      return;
    }

    // Helper function to wait while paused
    const waitIfPaused = async () => {
      if (controller && controller.isPaused) {
        // Create a promise that will be resolved when resume is called
        await new Promise((resolve) => {
          controller.resolvePromise = resolve;
        });
      }
    };

    const startNode = Object.keys(graph)[0];
    queue.push(startNode);
    setQueueNodes([startNode]);

    const timeout = (ms) => new Promise((res) => setTimeout(res, ms));

    const processNode = async (node) => {
      // Wait if paused before processing this node
      await waitIfPaused();

      setTraversedNode(node);
      await timeout(500); // Simulate delay for visualization
    };

    const updateVisitedNodes = (node) => {
      visited.add(node);
      setVisitedNodes(new Set(visited));
    };

    const updateQueueNodes = (currentQueue) => {
      setQueueNodes([...currentQueue]);
    };

    const bfs = async () => {
      while (queue.length > 0) {
        // Wait if paused before dequeuing
        await waitIfPaused();

        const node = queue.shift();
        updateQueueNodes([...queue]);

        if (!visited.has(node)) {
          await processNode(node);
          bfsOrder.push(node);
          updateVisitedNodes(node);

          // Wait if paused before processing neighbors
          await waitIfPaused();

          for (const neighbor of graph[node] || []) {
            if (!visited.has(neighbor) && !queue.includes(neighbor)) {
              queue.push(neighbor);
              updateQueueNodes([...queue]);

              // Small delay to visualize adding to queue
              await timeout(200);
            }
          }
        }
      }
      setTraversedNode("");
      resolve(bfsOrder);
    };

    bfs();
  });
};
